module.exports = __webpack_public_path__ + "img/LRSeleted.71d489d3.png";